import { Layout } from "#ce/components/SpLayoutBuilder/models/layout";

/**
 * Instead of making a request to the API, layout builder stores data in the admin form's hidden input.
 * TODO: remove this once we rewrite page builder with a proper API.
 */
class LayoutBuilderApi {
  #HIDDEN_INPUT_SELECTOR = "[id$=layout_grid_data]";
  #hiddenInput;

  get dataSource() {
    this.#hiddenInput ??= document.querySelector(this.#HIDDEN_INPUT_SELECTOR);

    if (!this.#hiddenInput) {
      throw new Error(`Page builder data source not found. (${this.#HIDDEN_INPUT_SELECTOR})`);
    }

    return this.#hiddenInput;
  }

  async find() {
    return new Layout(JSON.parse(this.dataSource.value));
  }

  async save(data, { dispatchChangeEvent = true } = {}) {
    this.dataSource.value = JSON.stringify(data);

    if (dispatchChangeEvent) {
      // page_builder.js.erb listens for this to trigger a preview reload
      this.dataSource.dispatchEvent(new Event("change", { bubbles: true }));
    }

    return data;
  }
}

let api;

export function createLayoutBuilderApi() {
  api ??= new LayoutBuilderApi();

  return {
    find: () => api.find(),
    save: (data, options) => api.save(data, options),
  };
}
